import { routes } from 'router/constants';

import { env } from './env';

const USE_MOCKED_USER = env.VITE_USE_MOCKED_USER;
const USE_MOCK = USE_MOCKED_USER;

const DETECT_MUTATIONS = env.VITE_DETECT_MUTATIONS;
const LOG_SAGA_TIME = env.VITE_LOG_SAGA_TIME;
const SLOW_DOWN_SAGA = env.VITE_SLOW_DOWN_SAGA;
const REACT_STRICT_MODE = env.VITE_REACT_STRICT_MODE;

const START_PAGE = routes.improvement.improvements;
const MISSING_VALUE = 'MISSING';

export {
  DETECT_MUTATIONS,
  LOG_SAGA_TIME,
  MISSING_VALUE,
  REACT_STRICT_MODE,
  SLOW_DOWN_SAGA,
  START_PAGE,
  USE_MOCK,
  USE_MOCKED_USER,
};
